module.exports = __webpack_public_path__ + "static/img/device_count2.ce07d9a3.gif";